const memoize = require('lodash/memoize');
const { track, identify, commonEvents } = require('@ordergroove/tracking/dist/client');

function TrackingService(msiConfig, subscriptionService) {
  const getSubscriberStatus = memoize(() => {
    return subscriptionService.getAll({ pagination: { pageSize: 1 } })
      .then((res) => {
        return res.length > 0;
      })
      .catch((err) => {
        if (err.status === 403) {
          return false;
        }
        throw err;
      });
  });

  this.initTracking = function() {
    identify(msiConfig.auth.public_id, msiConfig.auth.sig_field);
    return this.trackEvent(commonEvents.INITIAL_PAGE_VIEW);
  };

  this.trackEvent = function(eventName, properties = {}) {
    return getSubscriberStatus().then((subscriberStatus) => {
      const defaultProperties = {
        is_subscriber: subscriberStatus,
        authentication_status: 'authenticated'
      };
      track(eventName, { ...defaultProperties, ...properties });
    });
  };
}

TrackingService.$inject = ['config', 'ogsdk.subscriptionService'];

module.exports = TrackingService;
